<template>
    <div>
        <ul class="nav nav-pills mb-3" role="tablist">
            <li class="nav-item" v-for="tab in tabs" role="presentation">
                <a :href="'#tab-' + tab.name.toLowerCase().replace(/[\W_\s]/g, '')" class="nav-link" :class="{ 'active': tab.isActive }" data-toggle="pill" role="tab" :aria-selected="tab.isActive ? 'true' : 'false'">
                    {{ tab.name }}
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                tabs: []
            }
        },

        created() {
            this.tabs = this.$children;
        }
    }
</script>